module.exports = __webpack_public_path__ + "web-assets/img/status.55fa5878.png";